<template>
    <div class="table-responsive">
        <table>
            <thead>
                <tr>
                    <th>Tipo</th>
                    <th>Servidor IN</th>
                    <th>Servidor OUT</th>
                    <th>Usuario</th>
                    <th>Contraseña</th>
                    <th>Puerto</th>
                    <th>
                        <div>
                            <button type="button" @click="agregar" class="btn-success"><i class="fa fa-plus"></i></button>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(parametro, index) in parametros" :key="index">
                    <td>
                        <div class="form-field select">
                            <div class="select-field">
                                <select v-model="parametro.type" name="type[]" :id="'type' + index">
                                    <option value="">Seleccione...</option>
                                    <option value="FTP">FTP</option>
                                    <option value="SFTP">SFTP</option>
                                </select>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field v-model="parametro.server" input-out placeholder="Host o IP de servidor" :id="'server' + index" name="server[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field v-model="parametro.server_out" input-out placeholder="Host o IP de servidor" :id="'server_out' + index" name="server_out[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field v-model="parametro.user_id" input-out placeholder="Usuario" :id="'user_id' + index" name="user_id[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field type="password" v-model="parametro.password" input-out placeholder="Contraseña" :id="'password_param' + index" name="password_param[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <div class="form-field">
                            <input-field v-mask="'######'" v-model="parametro.port" input-out placeholder="Puerto" :id="'puerto' + index" name="port[]"></input-field>
                        </div>
                    </td>
                    <td>
                        <button type="button" @click="eliminar(index)" class="btn-danger btn--text"><i class="fa fa-trash"></i></button>
                    </td>
                </tr>
                <tr v-show="parametros.length == 0">
                    <td colspan="7">
                        <strong>No se ha agregado parámetros.</strong>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        }
    },
    data: function () {
        return {
            parametros: this.value
        };
    },
    methods: {
        eliminar: function (index) {
            this.parametros.splice(index, 1);
        },
        agregar: function () {
            this.parametros.push({
                type: '',
                server: '',
                server_out: '',
                user_id: '',
                password: '',
                port: ''
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/clientes/TablaParametrosCliente.vue